module.exports = "<div *ngIf=\"guides\" class=\"guides-master col-md-12 paper-sheet\">\n\n  <div class=\"title\"><h5>Latest from Nomadic</h5></div>\n  <hr />\n\n  <div class=\"col-md-12\">\n    <ul class=\"tile-list col-md-12\">\n      <li *ngFor=\"let guide of guides\" class=\"guide\">\n        <a [routerLink]=\"['guides', guide.id]\">\n          <app-tile [info]=\"guide\" [tileType]=\"'guide'\"></app-tile>\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/guides/guides.component.html
// module id = ../../../../../src/app/dashboard/guides/guides.component.html
// module chunks = 2